/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable react/no-unknown-property */
/* eslint-disable @next/next/no-img-element */
import React from 'react';
import Style from './LeilaoDeVeiculosConheca.css';
import ContainerHome24 from '@/components/atoms/ContainerHome24';
import CustomEmblaCarouselHome24 from '../CustomEmblaCarouselHome24';
import { useLayout } from '@/utils/useLayout';

function LeilaoDeVeiculosConheca() {
  const { width } = useLayout();
  return (
    <>
      <section id="leilao-de-veiculos-conheca">
        <div className="leilao-de-veiculos-conheca-p1">
          <ContainerHome24>
            <img src="assets/leilao-de-veiculos/img-leilao-conheca.svg" alt="ilustração" />
            <div className="por-que-textos">
              <h3 className="por-que-titulo">Conheça o leilão de veículos</h3>
              <p className="por-que-subtitulo">
                O leilão de veículos Santander pode proporcionar diversas vantagens para você que
                procura pelo veículo próprio:
              </p>
            </div>
          </ContainerHome24>
        </div>
        <div className="leilao-de-veiculos-conheca-p2">
          <ContainerHome24>
            <div>
              <CustomEmblaCarouselHome24
                // loop
                enableBullets
                detectBulletCount
                hideOverflow
                enableMobileArrows
                enablePrevArrow
                //autoplay={100000}
              >
                {({ className }) => (
                  <>
                    <div className={`slide ${className}`}>
                      <img src="assets/leilao-de-veiculos/ic_offer.svg" alt="" />
                      <p className="slide-texo">
                        Preços abaixo
                        <br />
                        da Fipe
                      </p>
                    </div>
                    <div className={`slide ${className}`}>
                      <img src="assets/leilao-de-veiculos/ic_paper_stack.svg" alt="" />
                      <p className="slide-texo">
                        Processo
                        <br />
                        organizado
                      </p>
                    </div>
                    <div className={`slide ${className}`}>
                      <img src="assets/leilao-de-veiculos/ic_security_verified.svg" alt="" />
                      <p className="slide-texo">
                        Segurança em
                        <br />
                        sua negociação
                      </p>
                    </div>
                    <div className={`slide ${className}`}>
                      <img src="assets/leilao-de-veiculos/ic_career_agile.svg" alt="" />
                      <p className="slide-texo">
                        Processo
                        <br />
                        prático
                      </p>
                    </div>
                  </>
                )}
              </CustomEmblaCarouselHome24>
            </div>
          </ContainerHome24>
        </div>
        {width <= 992 && (
          <picture className="img-separador-leilao">
            <source type="image/webp" srcSet="assets/leilao-de-veiculos/separador-leilao.webp" />
            <source type="image/jpg" srcSet="assets/leilao-de-veiculos/separador-leilao.jpg" />
            <img
              src="assets/leilao-de-veiculos/separador-leilao.jpg"
              alt="Estacionamento com carros seminovos de leilão ao pôr do sol homologados pela Santander Financiamentos."
            />
          </picture>
        )}
        {width > 992 && (
          <picture className="img-separador-leilao">
            <source
              type="image/webp"
              srcSet="assets/leilao-de-veiculos/separador-leilao-desk.webp"
            />
            <source type="image/jpg" srcSet="assets/leilao-de-veiculos/separador-leilao-desk.jpg" />
            <img
              src="assets/leilao-de-veiculos/separador-leilao-desk.jpg"
              alt="Estacionamento com carros seminovos de leilão ao pôr do sol homologados pela Santander Financiamentos."
            />
          </picture>
        )}
      </section>
      <style jsx>{Style}</style>
    </>
  );
}

export default LeilaoDeVeiculosConheca;
